import { Box } from "@mui/material";
import React from "react";
import BannerSection from "../component/Home/BannerSection";
import ReviewCardSection from "../component/Home/ReviewSection";
import StreamLine from "../component/Home/StreamLine";
import DesSec from "../component/Home/DesSec";

const Home = () => {
  return (
    <Box sx={{ bgcolor: "#F8FAFF" }}>
      <BannerSection />
      <DesSec />
      <StreamLine />
      <ReviewCardSection />
    </Box>
  );
};

export default Home;
